"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const Integration_1 = require("../integrations/Integration");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
const OsmosysBaseEntity_1 = require("../OsmosysBaseEntity");
const User_1 = require("./User");
const WorkspaceMembership_1 = require("./WorkspaceMembership");
const Organization_1 = require("./Organization");
const FeatureFlags_1 = require("../core/FeatureFlags");
let Workspace = class Workspace extends OsmosysBaseEntity_1.OsmosysBaseEntity {
};
tslib_1.__decorate([
    type_graphql_1.Field(() => User_1.User),
    typeorm_1.ManyToOne(() => User_1.User, {
        cascade: true,
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], Workspace.prototype, "creatingUser", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Organization_1.Organization),
    typeorm_1.ManyToOne(() => Organization_1.Organization, {
        cascade: true,
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], Workspace.prototype, "organization", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column(),
    tslib_1.__metadata("design:type", String)
], Workspace.prototype, "name", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean, { nullable: true }),
    typeorm_1.Column({
        default: false,
        nullable: false,
    }),
    tslib_1.__metadata("design:type", Boolean)
], Workspace.prototype, "enableSubscriberTools", void 0);
tslib_1.__decorate([
    type_graphql_1.Field({ nullable: true }),
    typeorm_1.Column({ nullable: true }),
    tslib_1.__metadata("design:type", String)
], Workspace.prototype, "stripePaymentSourceID", void 0);
tslib_1.__decorate([
    type_graphql_1.Field({ nullable: true }),
    typeorm_1.Column({ nullable: true }),
    tslib_1.__metadata("design:type", String)
], Workspace.prototype, "helpLink", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({
        default: true,
    }),
    tslib_1.__metadata("design:type", Boolean)
], Workspace.prototype, "requirePaymentSource", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({
        default: false,
    }),
    tslib_1.__metadata("design:type", Boolean)
], Workspace.prototype, "isUserAnalyticsEnabled", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({
        default: false,
    }),
    tslib_1.__metadata("design:type", Boolean)
], Workspace.prototype, "isWorkspaceAnalyticsEnabled", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [WorkspaceMembership_1.WorkspaceMembership], { nullable: true }),
    typeorm_1.OneToMany(() => WorkspaceMembership_1.WorkspaceMembership, wsMembership => wsMembership.workspace),
    tslib_1.__metadata("design:type", Object)
], Workspace.prototype, "memberships", void 0);
tslib_1.__decorate([
    typeorm_1.OneToMany(() => Integration_1.Integration, integration => integration.workspace),
    tslib_1.__metadata("design:type", Array)
], Workspace.prototype, "integrations", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [String]),
    typeorm_1.Column({
        default: ['ContentSystem'],
        type: 'jsonb',
    }),
    class_validator_1.IsArray(),
    class_validator_1.ArrayUnique(),
    class_validator_1.IsJSON(),
    class_validator_1.IsIn(Integration_1.INTEGRATION_TYPES, {
        each: true,
    }),
    tslib_1.__metadata("design:type", Array)
], Workspace.prototype, "enabledIntegrationClasses", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => User_1.User, { nullable: true }),
    typeorm_1.ManyToOne(() => User_1.User, {
        cascade: true,
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], Workspace.prototype, "agreedToTermsOfServiceUser", void 0);
tslib_1.__decorate([
    type_graphql_1.Field({ nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'timestamp',
    }),
    tslib_1.__metadata("design:type", String)
], Workspace.prototype, "agreedToTermsOfServiceDate", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [String], { nullable: true })
    // @IsArray()
    ,
    typeorm_1.Column({
        default: [],
        nullable: true,
        type: 'jsonb',
    }),
    tslib_1.__metadata("design:type", Array)
], Workspace.prototype, "dashboardUrls", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => FeatureFlags_1.FeatureFlags),
    typeorm_1.Column({
        default: new FeatureFlags_1.FeatureFlags(),
        type: 'jsonb',
    }),
    tslib_1.__metadata("design:type", FeatureFlags_1.FeatureFlags)
], Workspace.prototype, "featureFlagOverrides", void 0);
Workspace = tslib_1.__decorate([
    type_graphql_1.ObjectType(),
    typeorm_1.Entity()
], Workspace);
exports.Workspace = Workspace;
class WorkspaceEntity extends Workspace {
    toString() {
        return this.name || `Workspace #${this.id}`;
    }
    toEndpoint() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return `/admin/workspaces/${this.id}`;
        });
    }
}
exports.WorkspaceEntity = WorkspaceEntity;
//# sourceMappingURL=Workspace.js.map